import { useMemo } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

const COLORS = ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF'];

const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: { display: true, position: 'top' as const },
        tooltip: {
            callbacks: {
                label: function (tooltipItem: any) {
                    const dataset = tooltipItem.dataset;
                    const dataValue = dataset.data[tooltipItem.dataIndex];
                    const label = dataset.label || '';
                    const total = dataset.data.reduce((acc: number, val: number) => acc + val, 0);
                    const percentage = ((dataValue / total) * 100).toFixed(2);
                    return `${label}: ${dataValue} bookings (${percentage}%)`;
                },
            },
        },
    },
};

const PieChart = ({ bookings }: { bookings: any[] }) => {
    const chartData = useMemo(() => {
        const paymentTypeCounts: Record<string, number> = {};

        bookings.forEach((booking: { payment_type: string }) => {
            const pt = booking.payment_type;
            paymentTypeCounts[pt] = (paymentTypeCounts[pt] || 0) + 1;
        });

        const labels = Object.keys(paymentTypeCounts);
        return {
            labels,
            datasets: [{
                label: 'Payment Type',
                data: Object.values(paymentTypeCounts),
                backgroundColor: COLORS,
                hoverBackgroundColor: COLORS,
            }],
        };
    }, [bookings]);

    return (
        <div className="w-full rounded-xl border bg-card p-3 lg:p-4 lg:max-w-[420px]">
            <p className="text-base lg:text-lg font-semibold">Payment Type</p>
            <div className="mt-3 h-72 lg:h-80">
                <Pie data={chartData} options={options} />
            </div>
        </div>
    );
};

export default PieChart;
